module.exports = {
	apiURL: 'https://odedim-api.pstv.co/',
    cdnUrl: 'https://odedim-api.pstv.co/_docs/',
	captchaSiteKey: '6Lc8P8cZAAAAAEsu1RdaJ0h4h8MnAyfmeTaZ7Nhv',
	sentryDSN: 'https://beeac0218abf320499de6c2e903eecf9@sentry.pstv.co/15',
}
